import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { DialogService } from '../../services/dialog.service';
import { GlobalService } from '../../services/global.service';
import { UserService } from '../../services/user.service';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'sd-video-widget-v2',
    templateUrl: './video-widget-v2.component.html',
    styleUrls: ['./video-widget-v2.component.scss']
})
export class VideoWidgetV2Component implements OnInit, OnChanges {

    @Input() data: any;
    video: any;
    from = '';
    fromForGA = '';
    for = '';
    spotlight = '';
    label = '';
    urlSafe: SafeResourceUrl;


    constructor(
        public dialog: DialogService,
        public global: GlobalService,
        public user: UserService,
        public sanitizer: DomSanitizer,
        private router: Router
    ) {
    }

    ngOnInit() {
        //

        if (typeof (this.data.for) !== undefined) {
            this.for = this.data.for;
            this.spotlight = this.data.spotlight;
            this.label = this.data.label;
        }
        //   if (typeof (this.data.video.video_slug) !== undefined) {
        //         this.data.video.video_slug=this.data.video.slug_uservideo

        //     }
        if (!this.data.skeletonLoading) {
            this.video = this.data.video;
        }

        if (this.data.from != '' && this.data.from != undefined && this.data.from != null) {
            this.from = this.data.from;
            this.fromForGA = this.from + ' ' + this.router.url;
        } else {
            this.fromForGA = this.router.url;
        }




    }

    ngOnChanges() {
        // Update video whenever input chnage
        this.video = this.data.video;
    }

    editVideo() {
        this.router.navigate(['/video-upload'], { queryParams: { slug: this.video.video_slug } });
    }
}
